import './tenants-access.scss'

import { Button, notification, Table, Typography } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import axios from 'axios'
import React, { useState } from 'react'
import { Column, Row } from 'react-display-flex'
import useSWR from 'swr'

import { fetcher } from '../../../api'
import { EditableRow } from '../../../components/tables/AntEditableRow'
import { SelectEditableCell } from '../../../components/tables/AntSelectEditableCell'
import { Tenant } from '../../Tenants/models'
import { messages } from '../messages'
import { UserTableItem, UserTenantTableItem } from '../models'
import { buildTenantsAccessTableColumns } from './tenant-access-table-columns'

const tableComponents = {
  body: {
    row: EditableRow,
    cell: SelectEditableCell,
  },
}

export const TenantsAccess = ({ user }: { user: UserTableItem }) => {
  const [userTenants, setUserTenants] = useState(user.tenants || [])
  const { data: tenants } = useSWR<Tenant[]>('/tenants', fetcher)

  const newTenant = buildNewTenantInitialData()

  const addTenantAccessRow = () => {
    const nextUserTenants = Array.from(userTenants).concat(newTenant)

    setUserTenants(nextUserTenants)
  }

  const onChangeTenant = async (tenant: UserTenantTableItem) => {
    if (tenant.domain === newTenant.domain || tenant.role === newTenant.role) {
      return
    }

    try {
      const userTenant = { userId: user.id, tenantId: tenant.id, role: tenant.role, status: tenant.status }
      await axios.put('/user-tenant', userTenant)

      notification.success({
        message: messages.common.success,
        description: tenant?.temporaryId ? messages.user.enabled : messages.user.changedRole,
      })
      setUserTenants(removeTemporaryFromChangedItem(userTenants, tenant))
    } catch (error) {
      notification.error({ message: messages.common.error, description: messages.user.updateTenantError })
    }
  }

  const onDeleteUserTenantAccess = async (tenant: UserTenantTableItem) => {
    try {
      await axios.delete(`/tenants/${tenant.id}/users/${user.id}`)

      notification.success({ message: messages.common.success, description: messages.user.deletedTenantAccess })
      setUserTenants(userTenants.filter((userTenant) => userTenant.id !== tenant.id))
    } catch (error) {
      notification.error({ message: messages.common.error, description: messages.user.deletedTenantAccessError })
    }
  }

  const columns = buildTenantsAccessTableColumns({
    setUserTenants,
    onChangeTenant,
    onDeleteUserTenantAccess,
    userTenants,
    tenants,
  })

  return (
    <Column className="tenant-access">
      <Row justifyContentSpaceBetween>
        <Typography.Title level={3}>Allow Tenant Access</Typography.Title>
        <Button onClick={addTenantAccessRow}>Add new tenant access</Button>
      </Row>

      <Table
        className="user-by-tenants-table"
        components={tableComponents}
        columns={columns as ColumnsType}
        dataSource={userTenants}
        loading={user?.tenants === null}
        pagination={false}
        rowKey="id"
        size="small"
      />
    </Column>
  )
}

const buildNewTenantInitialData = () => ({
  id: new Date().getTime(),
  temporaryId: new Date().getTime(),
  name: 'Tenant name',
  domain: 'Select a tenant',
  role: 'Select a role',
})

const removeTemporaryFromChangedItem = (userTenants: UserTenantTableItem[], currentTenant: UserTenantTableItem) =>
  userTenants.map((userTenant) => ({
    ...userTenant,
    temporaryId: userTenant.id === currentTenant.id ? undefined : userTenant.temporaryId,
  }))
